import { TableColumn } from '@shared';

/** API search fields for the single-dealer licenses toolbar */
export const SINGLE_DEALER_LICENSE_SEARCH_FIELDS = ['licenseId', 'licenseKey', 'alias'] as const;

/**
 * License columns for the single-dealer admin view; index column comes from the table's `hasIndex` flag.
 */
export const SINGLE_DEALER_LICENSE_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'licenseKey',
        header: 'License Key',
        width: '250px',
        type: 'status-copy',
        hasRedirect: true,
        truncateLimit: 0,
    },
    { field: 'alias', header: 'Alias', width: '150px' },
    { field: 'anydesk', header: 'Anydesk', width: '180px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '100px',
        type: 'actions',
        actions: [{ icon: 'delete', name: 'delete', color: '#E73535' }],
    },
];
